// utils
import _ from 'lodash';
import { codeGeneretor } from 'app/utils';
import { PAD_ITEM_TYPE } from 'app/config/pad_item';
const TEMPLATE_NAME = 'PAD_MODEL_CREATOR_ITEM_EQUIPMENT';

const initialState = () => ({
  screenData: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;
      const type = PAD_ITEM_TYPE.EQUIPMENT;
      const code = codeGeneretor();
      const padModelItemEquipment = {
        ...newData.data,
        code,
        type
      };

      const screenData = [...state.screenData, padModelItemEquipment];

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padModelItemEquipmentEdited = { ...newData.data, type: PAD_ITEM_TYPE.EQUIPMENT };

      const screenData = _.cloneDeep(state.screenData);

      const indexScreen = screenData.findIndex(
        padItem => padItem.code === padModelItemEquipmentEdited.code
      );
      screenData.splice(indexScreen, 1, padModelItemEquipmentEdited);

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padModelItemEquipment = { ...newData.data };

      const screenData = _.cloneDeep(state.screenData).filter(
        padVisit => padVisit.code !== padModelItemEquipment.code
      );

      return {
        ...state,
        screenData
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
